import { atom, selector } from 'recoil';

export const countMsgState = atom({
  key: 'countMsgState',
  default: {},
});
export default countMsgState;
